/* global $ */

const windowBreakpoint = 968;

if ($(window).width() >= windowBreakpoint) {
  $('#usMap a path, #usMap a polygon').mouseenter((e) => {
    $('#info-box').css('display', 'block');
    const stateName = $(e.target)
      .parent('a')
      .data('state-title');
    $('#info-box h2').html(stateName);
    // const stateId = stateName.replace(/\s+/g, '-').toLowerCase();

    // $(e.target).attr('id', stateId);

    // const useHtml = '<use id="use" xlink:href="#' + stateId + '" />';

    $('#usMap').append($(e.target).parent('a'));
  });
  $('#usMap a path, #usMap a polygon').mouseleave(() => {
    $('#info-box').css('display', 'none');
    $('#usMap use').remove();
  });

  let windowWidth = $(window).width();

  $(window).on('resize', () => {
    windowWidth = $(window).width();
  });

  $(document)
    .mousemove((e) => {
      const mouseX = e.pageX + 50;
      const mouseY = e.pageY - 30;
      const boxWidth = $('#info-box').width();
      const mouseXLeft = e.pageX - boxWidth - 50;

      const windowWidthHalf = windowWidth / 2;

      if (e.pageX > windowWidthHalf) {
        $('#info-box').css({
          top: mouseY,
          left: mouseXLeft,
        });
      } else {
        $('#info-box').css({
          top: mouseY,
          left: mouseX,
        });
      }
    })
    .mouseover();
  const wordStates = $('.state-list');
  const $svpMap = $('#usMap');
  wordStates.on('mouseenter mouseleave', 'li', (e) => {
    const { type, target } = e;
    const $target = $(target);
    const stateCode = $target.data('state');
    wordStates.find('.on').removeClass('on');
    $svpMap.find('.on').removeClass('on');
    console.log({ type, stateCode });
    if (!stateCode) {
      return false;
    }
    const svgState = $svpMap.find('.' + stateCode);
    if (!svgState.length) {
      return false;
    }
    if (type === 'mouseenter') {
      $target.addClass('on');
      $('#usMap').append(svgState);
      svgState.addClass('on');
      console.log('in', stateCode);
      // Info Box
      $('#info-box').css('display', 'block');
      const stateName = $target.data('state-title');
      $('#info-box h2').html(stateName);
    } else {
      $target.removeClass('on');
      svgState.removeClass('on');
      console.log('out', stateCode);
      // Info Box
      $('#info-box').css('display', 'none');
    }
    return true;
  });
}
